// extracted by mini-css-extract-plugin
export default {"signature-button":"SignatureButton_signature-button__1BZeL","dateLabel":"SignatureButton_dateLabel__wQYHt"};